import api from "api";
import { Checklist } from "models/Checklist";
import { MediaThumbnail } from "models/MediaThumbnail";

export type GetAllThumbnailsRequest = Checklist;
export type GetAllThumbnailsResponse = MediaThumbnail[];

export const getAllThumbnails = async (checklist: GetAllThumbnailsRequest) =>
  Promise.all(checklist.verification.map((item) => getThumbnailMedia(item.id)));

const getThumbnailMedia = async (id: string): Promise<MediaThumbnail> => {
  const blob = await api.bin.getThumbnail(id);
  return {
    id: id,
    imgUrl: window.URL.createObjectURL(blob),
    mediaType: blob.type,
  };
};
